// Auto-extracted from pdcspas.com model pages — full specs, standard features & exclusive options.
export const PDC_SPECS = {
 "pdc-bali": {
  "specs": [
   [
    "Dimension",
    "94\" (7'10\") square x 39\" (3'3\")"
   ],
   [
    "Hot Tub Seating",
    "7 seats; 2 open buckets, 4 contoured buckets, Captain's Chair"
   ],
   [
    "Capacity",
    "650 Gallons, 2,460 Liters"
   ],
   [
    "Weight",
    "Dry: 908 lbs, Wet: 6,108 lbs."
   ],
   [
    "Hot Tub Jets",
    "143 Stainless Steel Reflections Jets™; 70 hydrotherapy hot tub jets, 73 spa air massage jets, UltraMassage™ Selector, Air'assage™ Therapy"
   ],
   [
    "Hot Tub Power",
    "(2) 12 HP Peak (6HP Continuous); 1.5HP Bubbler"
   ],
   [
    "Spa Warranty",
    "35 year structural warranty; 15 year finish warranty; 5 year electric component & plumbing warranty; 3 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full acrylic color selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(3) Cascading Spouts",
   "SmartView Digital Control",
   "TemperLok™ & TemperBase™",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Halo LED Lighting™",
   "All Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Allure2™ Lighting",
   "Spectrum Lighting",
   "EverPure2™ Purification System",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-biscayne": {
  "specs": [
   [
    "Dimension",
    "90\" (7'6\") x 79\" (6'7\") x 37\" (3'1\")"
   ],
   [
    "Hot Tub Seating",
    "5 seats; 4 contoured buckets, 1 lounge"
   ],
   [
    "Capacity",
    "325 Gallons, 1,230 Liters"
   ],
   [
    "Weight",
    "Dry: 800 lbs, Wet: 3,670 lbs."
   ],
   [
    "Hot Tub Jets",
    "96 Stainless Steel Reflections Jets™; 66 hydrotherapy hot tub jets, 30 spa air massage jets, UltraMassage™ Selector, Air'assage™ Therapy"
   ],
   [
    "Hot Tub Power",
    "(2) 12HP Peak (6HP Continuous); 1.5HP Bubbler"
   ],
   [
    "Spa Warranty",
    "35 year structural warranty; 15 year finish warranty; 5 year electric component & plumbing warranty; 3 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full acrylic color selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(3) Cascading Spouts",
   "SmartView Digital Control",
   "TemperLok™ & TemperBase™",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Halo LED Lighting™",
   "All Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Allure2™ Lighting",
   "Spectrum Lighting",
   "EverPure2™ Purification System",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-fiji": {
  "specs": [
   [
    "Dimension",
    "94\" (7'10\") square x 39\" (3'3\")"
   ],
   [
    "Hot Tub Seating",
    "6 seats: 3 contoured buckets, open bucket, lounge, captain's chair"
   ],
   [
    "Capacity",
    "525 Gallons, 1,987 Liters"
   ],
   [
    "Weight",
    "Dry: 865 lbs, Wet: 5,065 lbs."
   ],
   [
    "Hot Tub Jets",
    "115 Stainless Steel Reflections Jets™; 71 hydrotherapy hot tub jets, 44 spa air massage jets, UltraMassage™ Selector, Air'assage™ Therapy"
   ],
   [
    "Hot Tub Power",
    "(2) 12HP Peak (6HP Continuous); 1.5HP Bubbler"
   ],
   [
    "Spa Warranty",
    "35 year structural warranty; 15 year finish warranty; 5 year electric component & plumbing warranty; 3 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full acrylic color selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(3) Cascading Spouts",
   "SmartView Digital Control",
   "TemperLok™ & TemperBase™",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Halo LED Lighting™",
   "All Acrylic Shell Colors",
   "PDC Spas Pre-lit logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Allure2™ Lighting",
   "Spectrum Lighting",
   "EverPure2™ Purification System",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-malibu": {
  "specs": [
   [
    "Dimension",
    "82\" (6'10\") square x 37\" (3'1\")"
   ],
   [
    "Hot Tub Seating",
    "5 seats, one open seat, 3 contoured bucket seats, lounge"
   ],
   [
    "Capacity",
    "400 Gallons, 1,514 Liters"
   ],
   [
    "Weight",
    "Dry: 635 lbs, Wet: 3,835 lbs."
   ],
   [
    "Hot Tub Jets",
    "97 Stainless Steel Reflections Jets™; 57 hydrotherapy hot tub jets, 40 spa air massage jets, UltraMassage™ Selector, Air'assage™ Therapy"
   ],
   [
    "Hot Tub Power",
    "(2) 12HP Peak (6HP Continuous)"
   ],
   [
    "Spa Warranty",
    "35 year structural warranty; 15 year finish warranty; 5 year electric component & plumbing warranty; 3 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full acrylic color selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(3) Cascading Spouts",
   "SmartView Digital Control",
   "TemperLok™ & TemperBase™",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Halo LED Lighting™",
   "All Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Allure2™ Lighting",
   "Spectrum Lighting",
   "EverPure2™ Purification System",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-reno": {
  "specs": [
   [
    "Dimension",
    "86\" (7'2\") square x 37\" (3'1\")"
   ],
   [
    "Hot Tub Seating",
    "6 seats; 2 lounges, 3 contoured buckets, extra wide bucket"
   ],
   [
    "Capacity",
    "375 Gallons, 1,420 Liters"
   ],
   [
    "Weight",
    "Dry: 705 lbs, Wet: 3,705 lbs."
   ],
   [
    "Hot Tub Jets",
    "117 Stainless Steel Reflections Jets™; 66 hydrotherapy hot tub jets, 51 spa air massage jets, UltraMassage™ Selector, Air'assage™ Therapy"
   ],
   [
    "Hot Tub Power",
    "(2) 12HP Peak (6HP Continuous); 1.5HP Bubbler"
   ],
   [
    "Spa Warranty",
    "35 year structural warranty; 15 year finish warranty; 5 year electric component & plumbing warranty; 3 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full acrylic color selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(3) Cascading Spouts",
   "SmartView Digital Control",
   "TemperLok™ & TemperBase™",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Halo LED Lighting™",
   "All Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Allure2™ Lighting",
   "Spectrum Lighting",
   "EverPure2™ Purification System",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-barbados": {
  "specs": [
   [
    "Dimension",
    "94\" (7'10\") square x 39\" (3'3\")"
   ],
   [
    "Hot Tub Seating",
    "7 seats; 2 open buckets, 4 contoured buckets, Captain's Chair"
   ],
   [
    "Capacity",
    "650 Gallons, 2,460 Liters"
   ],
   [
    "Weight",
    "Dry: 775 lbs., Wet: 5,975 lbs."
   ],
   [
    "Hot Tub Jets",
    "62 Stainless Steel Reflection Jets™"
   ],
   [
    "Hot Tub Power",
    "(2) Pumps 8 HP Peak (4HP continuous)"
   ],
   [
    "Spa Warranty",
    "25 year structural warranty; 15 year finish warranty; 3 year electric component & plumbing warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(2) Cascading Spouts",
   "ProView Digital Control",
   "Temperlok™ & TemperBase™",
   "Deluxe Thermal Cover",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Prism LED Lighting™",
   "3 Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Additional Color Choices",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-carmel": {
  "specs": [
   [
    "Dimension",
    "60\" (5') x 84\" (7') x 33\" (2'8\")"
   ],
   [
    "Hot Tub Seating",
    "3 seats; reversible recliner, 2 bucket seats"
   ],
   [
    "Capacity",
    "220 Gallons, 832 Liters"
   ],
   [
    "Weight",
    "Dry: 575 lbs., Wet: 2,335 lbs."
   ],
   [
    "Hot Tub Jets",
    "28 Stainless Steel Reflection Jets™"
   ],
   [
    "Hot Tub Power",
    "(1) Pump 4 HP Peak (2HP continuous)"
   ],
   [
    "Spa Warranty",
    "25 year structural warranty; 15 year finish warranty; 3 year electric component & plumbing warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(2) Cascading Spouts",
   "ProView Digital Control",
   "Temperlok™ & TemperBase™",
   "Deluxe Thermal Cover",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Prism LED Lighting™",
   "3 Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Additional Color Choices",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-catalina": {
  "specs": [
   [
    "Dimension",
    "90\" (7'6\") x 79\" (6'7\") x 37\" (3'1\")"
   ],
   [
    "Hot Tub Seating",
    "5 seats; 4 contoured buckets, 1 lounge"
   ],
   [
    "Capacity",
    "325 Gallons, 1,230 Liters"
   ],
   [
    "Weight",
    "Dry: 695 lbs., Wet: 3,295 lbs."
   ],
   [
    "Hot Tub Jets",
    "54 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "(2) Pumps 8HP Peak (4HP continuous)"
   ],
   [
    "Spa Warranty",
    "25 year structural warranty; 15 year finish warranty; 3 year electric component & plumbing warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(2) Cascading Spouts",
   "ProView Digital Control",
   "Temperlok™ & TemperBase™",
   "Deluxe Thermal Cover",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Prism LED Lighting™",
   "3 Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Additional Color Choices",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-denali": {
  "specs": [
   [
    "Dimension",
    "82\" (6'8\") square x 39\" (3'3\")"
   ],
   [
    "Hot Tub Seating",
    "7 seats; 6 contoured buckets, open bucket"
   ],
   [
    "Capacity",
    "425 Gallons, 1,609 Liters"
   ],
   [
    "Weight",
    "Dry: 645 lbs., Wet: 4,045 lbs."
   ],
   [
    "Hot Tub Jets",
    "61 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "(2) Pumps 8HP Peak (4HP continuous)"
   ],
   [
    "Spa Warranty",
    "25 year structural warranty; 15 year finish warranty; 3 year electric component & plumbing warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(2) Cascading Spouts",
   "ProView Digital Control",
   "Temperlok™ & TemperBase™",
   "Deluxe Thermal Cover",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Prism LED Lighting™",
   "3 Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Additional Color Choices",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-freeport": {
  "specs": [
   [
    "Dimension",
    "94\" (7'10\") square x 39\" (3'3\")"
   ],
   [
    "Hot Tub Seating",
    "6 seats, 3 contoured buckets, open bucket, lounge, captain's chair"
   ],
   [
    "Capacity",
    "520 Gallons, 1,968 Liters"
   ],
   [
    "Weight",
    "Dry: 750 lbs., Wet: 4,910 lbs."
   ],
   [
    "Hot Tub Jets",
    "61 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "(2) Pumps 8HP Peak (4HP continuous)"
   ],
   [
    "Spa Warranty",
    "25 year structural warranty; 15 year finish warranty; 3 year electric component & plumbing warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "(2) Cascading Spouts",
   "ProView Digital Control",
   "Temperlok™ & TemperBase™",
   "Deluxe Thermal Cover",
   "PowerFlo™ Filtration",
   "Reflections Jetting™",
   "EverPure™ Ozone w/EverLite™",
   "Prism LED Lighting™",
   "3 Acrylic Shell Colors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "SoundStream™ Audio System",
   "Additional Color Choices",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting"
  ]
 },
 "pdc-mirage": {
  "specs": [
   [
    "Dimension",
    "60\" (5\") x 84\" (7\") x 33\" (2'9\")"
   ],
   [
    "Hot Tub Seating",
    "3 seats; 2 buckets, lounge"
   ],
   [
    "Capacity",
    "200 Gallons, 757 Liters"
   ],
   [
    "Weight",
    "Dry: 450 lbs., Wet: 2,050 lbs."
   ],
   [
    "Hot Tub Jets",
    "29 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "4HP Dual Speed Pump (240V) / 2HP Pump (110V)"
   ],
   [
    "Spa Warranty",
    "10 year structural warranty; 10 year finish warranty; 2 year parts & plumbing warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "TemperLok™ Insulation",
   "TemperBase™ Hot Tub Floor",
   "Pristine™ Filtration",
   "EverPure™ Ozone with EverLite™",
   "Reflections Jetting™",
   "MotionGlow™ Lighting",
   "1 Acrylic Shell Color",
   "Accent Digital Control",
   "10 Year Hot Tub Warranty",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "WAVE™ WiFi Wireless Control",
   "4 Acrylic Shell Colors",
   "LuminX™ Lighting"
  ]
 },
 "pdc-seasons": {
  "specs": [
   [
    "Dimension",
    "82\" (6'10\") square x 36\" (3\")"
   ],
   [
    "Hot Tub Seating",
    "5 seats; 4 contoured buckets, lounge"
   ],
   [
    "Capacity",
    "375 Gallons, 1419 Liters"
   ],
   [
    "Weight",
    "Dry: 665 lbs., Wet: 3,665 lbs."
   ],
   [
    "Hot Tub Jets",
    "43 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "6 HP Dual Speed Pump"
   ],
   [
    "Spa Warranty",
    "10 year structural warranty; 10 year finish warranty; 2 year parts warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "TemperLok™ Insulation",
   "TemperBase™ Hot Tub Floor",
   "Pristine™ Filtration",
   "EverPure™ Ozone with EverLite™",
   "Reflections Jetting™",
   "MotionGlow™ Lighting",
   "1 Acrylic Shell Color",
   "Accent Digital Control",
   "10 Year Hot Tub Warranty",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "WAVE™ WiFi Wireless Control",
   "4 Acrylic Shell Colors",
   "LuminX™ Lighting"
  ]
 },
 "pdc-summit-ht": {
  "specs": [
   [
    "Dimension",
    "82\" (6'10\") square x 39\" (3'3\")"
   ],
   [
    "Hot Tub Seating",
    "7 seats; 6 contoured buckets, wide corner seat"
   ],
   [
    "Capacity",
    "425 Gallons, 1608 Liters"
   ],
   [
    "Weight",
    "Dry: 645 lbs., Wet: 4,045 lbs."
   ],
   [
    "Hot Tub Jets",
    "42 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "6 HP Dual Speed Pump"
   ],
   [
    "Spa Warranty",
    "10 year structural warranty; 10 year finish warranty; 2 year parts warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "TemperLok™ Insulation",
   "TemperBase™ Hot Tub Floor",
   "Pristine™ Filtration",
   "EverPure™ Ozone with EverLite™",
   "Reflections Jetting™",
   "MotionGlow™ Lighting",
   "1 Acrylic Shell Color",
   "Accent Digital Control",
   "10 Year Hot Tub Warranty",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "WAVE™ WiFi Wireless Control",
   "4 Acrylic Shell Colors",
   "LuminX™ Lighting"
  ]
 },
 "pdc-twilight": {
  "specs": [
   [
    "Dimension",
    "76\" (6'4\") square x 31\" (2'7\")"
   ],
   [
    "Hot Tub Seating",
    "5 seats; lounge and 4 contoured buckets"
   ],
   [
    "Capacity",
    "275 Gallons, 1040 Liters"
   ],
   [
    "Weight",
    "Dry: 530 lbs., Wet: 2,730 lbs."
   ],
   [
    "Hot Tub Jets",
    "27 Stainless Steel Reflections Jets™"
   ],
   [
    "Hot Tub Power",
    "4HP Dual Speed Pump (240V) / 2HP Pump (110V)"
   ],
   [
    "Spa Warranty",
    "10 year structural warranty; 10 year finish warranty; 2 year parts warranty; 1 year labor warranty"
   ],
   [
    "Hot Tub Color",
    "Full Acrylic Color Selection"
   ],
   [
    "Cabinet Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ]
  ],
  "included": [
   "TemperLok™ Insulation",
   "TemperBase™ Hot Tub Floor",
   "Pristine™ Filtration",
   "EverPure™ Ozone with EverLite™",
   "Reflections Jetting™",
   "MotionGlow™ Lighting",
   "1 Acrylic Shell Color",
   "Accent Digital Control",
   "10 Year Hot Tub Warranty",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "WAVE™ WiFi Wireless Control",
   "4 Acrylic Shell Colors",
   "LuminX™ Lighting"
  ]
 },
 "pdc-tsx15": {
  "specs": [
   [
    "Dimension",
    "180\" x 92\" x 56\" deep, 114\" fitness area"
   ],
   [
    "Design Features",
    "Wide entry steps positioned to maximize fitness area. Sculpted massage seat, open barrier-free fitness area, patented dual prop propulsion fitness stream for the widest, smoothest most balanced workout in the industry."
   ],
   [
    "Therapy Jets",
    "8 hydrotherapy stainless Reflections Jets™. Sculpted seat with shoulder, upper and lower back jetting."
   ],
   [
    "Swim Spa Power",
    "Fitness: Dual prop propulsion system, 5000 GPM; Therapy: 4HP, single pump; 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2240 Gallons, 8479 Liters"
   ],
   [
    "Weight (lbs.)",
    "1905 Dry, 16015 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "PowerFlo™ Filtration",
   "Patented TruSwim® Technology",
   "Reflections Jets™ Stainless Finish",
   "Highlights™ Lighting LED",
   "EverPure2™ Ozone with EverLite™",
   "TSX-SmartTouch™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "AquaBar™ Stainless Grip Bar",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse2™ Lighting",
   "BlueTune™ Audio",
   "WAVE™ WiFi Wireless Control",
   "AquaBalance™ Stainless Bars",
   "AquaForce™ Fitness Pulley",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-tsx17": {
  "specs": [
   [
    "Dimension",
    "204\" x 92\" x 56\" deep, 124\" fitness area"
   ],
   [
    "Design Features",
    "Wide curved entry steps, deep recliner and sculpted massage seats, open barrier-free fitness area, patented dual prop propulsion fitness stream for the widest, smoothest most balanced workout in the industry."
   ],
   [
    "Therapy Jets",
    "18 hydrotherapy stainless Reflections Jets™ for shoulder, upper and lower back, and calf hydrotherapy."
   ],
   [
    "Swim Spa Power",
    "Fitness: Dual prop propulsion system, 5000 GPM; Therapy: 4HP, single pump; 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2420 Gallons, 9160 Liters"
   ],
   [
    "Weight (lbs.)",
    "2045 Dry, 21405 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "PowerFlo™ Filtration",
   "Patented TruSwim® Technology",
   "Reflections Jets™ Stainless Finish",
   "Highlights™ Lighting LED",
   "EverPure2™ Ozone with EverLite™",
   "TSX-SmartTouch™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "AquaBar™ Stainless Grip Bar",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse2™ Lighting",
   "BlueTune™ Audio",
   "Aquapak™ Fitness Equipment",
   "WAVE™ WiFi Wireless Control",
   "AquaBalance™ Stainless Bars",
   "AquaForce™ Fitness Pulley",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-tsx19": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\" deep, 148\" fitness area"
   ],
   [
    "Design Features",
    "Wide curved entry steps, deep recliner and sculpted massage seats, open barrier-free fitness area, patented dual prop propulsion fitness stream for the widest, smoothest most balanced workout in the industry."
   ],
   [
    "Therapy Jets",
    "18 hydrotherapy stainless Reflections Jets™ for shoulder, upper and lower back, and calf hydrotherapy."
   ],
   [
    "Swim Spa Power",
    "Fitness: Dual prop propulsion system, 5000 GPM; Therapy: 4HP, single pump; 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2700 Gallons, 10220 Liters"
   ],
   [
    "Weight (lbs.)",
    "2250 Dry, 23850 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "PowerFlo™ Filtration",
   "Patented TruSwim® Technology",
   "Reflections Jets™ Stainless Finish",
   "Highlights™ Lighting LED",
   "EverPure2™ Ozone with EverLite™",
   "TSX-SmartTouch™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "AquaBar™ Molded Acrylic Grip",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse2™ Lighting",
   "BlueTune™ Audio",
   "WAVE™ WiFi Wireless Control",
   "AquaBalance™ Stainless Bars",
   "AquaForce™ Fitness Pulley",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-tsx219": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\" deep, 102\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with sculpted massage seat, open barrier-free fitness area, and patented dual prop propulsion. Hot tub zone is a full featured 5 deep seat spa. Separate zones with filtration, heating, therapy and fitness action controls."
   ],
   [
    "Therapy Jets",
    "37 hydrotherapy stainless Reflections Jets™ for shoulder, upper and lower back, and calf hydrotherapy."
   ],
   [
    "Dual Zone Power",
    "Fitness Zone: Dual prop propulsion system, 5000 GPM, 5.5KW heater, 50 amps; Hot Tub Zone: 12HP, 3 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2525 gallons (hot tub zone: 425 Gallons / Fitness Zone: 2100 Gallons)"
   ],
   [
    "Weight (lbs.)",
    "2735 Dry / 22935 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "PowerFlo™ Filtration",
   "Patented TruSwim® Technology",
   "Reflections Jets™ Stainless Finish",
   "Highlights™ Lighting LED",
   "EverPure2™ Ozone with EverLite™",
   "TSX-SmartTouch™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "AquaBar™ Molded Acrylic Grip",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse2™ Lighting",
   "BlueTune™ Audio",
   "WAVE™ WiFi Wireless Control",
   "AquaBalance™ Stainless Bars",
   "AquaForce™ Fitness Pulley",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-sx15": {
  "specs": [
   [
    "Dimension",
    "180\" x 92\" x 56\", 112\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "36 hydrotherapy stainless Reflections Jets™. Full body massage columns, reclining and sculpted seats with shoulder, upper and lower back, hips, calves and feet jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Trio of high powered resistance swim jets"
   ],
   [
    "Swim Spa Power",
    "22HP, 4 pumps. 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2140 Gallons, 8100 Liters"
   ],
   [
    "Weight (lbs.)",
    "1725 lbs Dry, 18,845 lbs Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown Cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 components / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "SmartView™ Control Center",
   "Locking Safety Thermal Cover",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-sx15s": {
  "specs": [
   [
    "Dimension",
    "180\" x 92\" x 56\", 130\" fitness area"
   ],
   [
    "Design Features",
    "Wide entry steps positioned to maximize fitness area. Sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "20 hydrotherapy stainless Reflections Jets™. Full body massage columns, sculpted seat with shoulder, upper and lower back jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Trio of high powered resistance swim jets"
   ],
   [
    "Swim Spa Power",
    "22HP, 4 pumps. 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2240 Gallons, 8479 Liters"
   ],
   [
    "Weight (lbs.)",
    "1725 lbs Dry, 18,845 lbs Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "SmartView™ Control Center",
   "Locking Safety Thermal Cover",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-sx17": {
  "specs": [
   [
    "Dimension",
    "204\" x 92\" x 56\", 136\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "36 hydrotherapy stainless Reflections Jets™. Full body massage columns, reclining and sculpted seats with shoulder, upper and lower back, hips, calves and feet jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Trio of high powered resistance swim jets"
   ],
   [
    "Swim Spa Power",
    "22HP, 4 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2420 Gallons, 9160 Liters"
   ],
   [
    "Weight (lbs.)",
    "1860 Dry, 21220 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "SmartView™ Control Center",
   "Locking Safety Thermal Cover",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-sx19": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\", 160\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "36 hydrotherapy stainless Reflections Jets™. Full body massage columns, reclining and sculpted seats with shoulder, upper and lower back, hips, calves and feet jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Trio of high powered resistance swim jets"
   ],
   [
    "Swim Spa Power",
    "22HP, 4 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2700 Gallons, 10220 Liters"
   ],
   [
    "Weight (lbs.)",
    "2065 Dry, 23755 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "SmartView™ Control Center",
   "Locking Safety Thermal Cover",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-sx219": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\", 100\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns. Hot tub zone is a full featured 5 deep seat spa. Separate zones with filtration, heating, therapy and fitness action controls."
   ],
   [
    "Therapy Jets",
    "64 hydrotherapy stainless Reflections Jets™. Full body massage columns. Shoulder, upper and lower back, hips, calves and feet in 7 seats."
   ],
   [
    "Elite Pro™ Jets",
    "Trio of high powered resistance swim jets"
   ],
   [
    "Dual Zone Power",
    "Fitness Zone: 22HP, 4 pumps, 5.5KW heater, 50 amp; Hot Tub Zone: 8HP, 2 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2425 Gallons, 9558 Liters (hot tub zone: 425 Gallons / Fitness Zone: 2000 Gallons)"
   ],
   [
    "Weight (lbs.)",
    "2550 Dry, 21950 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "SmartView™ Control Centers",
   "Locking Safety Thermal Cover",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "WAVE™ WiFi Wireless Control",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-sx219s": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\", 118\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns. Hot tub zone is a full featured 5 deep seat spa. Separate zones with filtration, heating, therapy and fitness action controls."
   ],
   [
    "Therapy Jets",
    "49 hydrotherapy stainless Reflections Jets™. Full body massage columns. Shoulder, upper and lower back, and hips in 6 seats."
   ],
   [
    "Elite Pro™ Jets",
    "Trio of high powered resistance swim jets"
   ],
   [
    "Dual Zone Power",
    "Fitness Zone: 22HP, 4 pumps, 5.5KW heater, 50 amps; Hot Tub Zone: 8HP, 2 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2525 gallons, 9558 Liters (hot tub zone: 425 Gallons / Fitness Zone: 2100 Gallons)"
   ],
   [
    "Weight (lbs.)",
    "2550 Dry, 22750 Wet"
   ],
   [
    "Finish",
    "Silver Marble Sun acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "SmartView™ Control Centers",
   "Proview™ Control Center",
   "Locking Safety Thermal Cover",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-fx15": {
  "specs": [
   [
    "Dimension",
    "180\" x 92\" x 56\", 112\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "36 hydrotherapy stainless Reflections Jets™. Full body massage columns, reclining and sculpted seats with shoulder, upper and lower back, hips, calves and feet jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Dual line up of high powered adjustable swim jets"
   ],
   [
    "Swim Spa Power",
    "16HP, 3 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2140 Gallons, 8100 Liters"
   ],
   [
    "Weight (lbs.)",
    "1645 Dry, 18765 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown Cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 components / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "FX-Proview™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "TempLock Technology",
   "Aqua Resistance Bands"
  ]
 },
 "pdc-fx15s": {
  "specs": [
   [
    "Dimension",
    "180\" x 92\" x 56\", 130\" fitness area"
   ],
   [
    "Design Features",
    "Wide entry steps positioned to maximize fitness area. Sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "20 hydrotherapy stainless Reflections Jets™. Full body massage columns, sculpted seat with shoulder, upper and lower back jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Dual line up of high powered adjustable swim jets"
   ],
   [
    "Swim Spa Power",
    "16HP, 3 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2240 Gallons, 8479 Liters"
   ],
   [
    "Weight (lbs.)",
    "1645 Dry, 19565 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "FX-Proview™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "TempLock Technology"
  ]
 },
 "pdc-fx17": {
  "specs": [
   [
    "Dimension",
    "204\" x 92\" x 56\", 136\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "36 hydrotherapy stainless Reflections Jets™. Full body massage columns, reclining and sculpted seats with shoulder, upper and lower back, hips, calves and feet jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Dual line up of high powered adjustable swim jets"
   ],
   [
    "Swim Spa Power",
    "16HP, 3 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2420 Gallons, 9160 Liters"
   ],
   [
    "Weight (lbs.)",
    "1784 Dry, 21144 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "FX-Proview™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "TempLock Technology"
  ]
 },
 "pdc-fx19": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\", 160\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns."
   ],
   [
    "Therapy Jets",
    "36 hydrotherapy stainless Reflections Jets™. Full body massage columns, reclining and sculpted seats with shoulder, upper and lower back, hips, calves and feet jetting."
   ],
   [
    "Elite Pro™ Jets",
    "Dual line up of high powered adjustable swim jets"
   ],
   [
    "Swim Spa Power",
    "16HP, 3 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2700 Gallons, 10220 Liters"
   ],
   [
    "Weight (lbs.)",
    "1900 Dry, 23590 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "FX-Proview™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "TempLock Technology"
  ]
 },
 "pdc-fx219": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\", 100\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with full body recliner and sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns. Hot tub zone is a full featured 5 deep seat spa. Separate zones with filtration, heating, therapy and fitness action controls."
   ],
   [
    "Therapy Jets",
    "65 hydrotherapy stainless Reflections Jets™. Full body massage columns. Shoulder, upper and lower back, hips, calves and feet in 7 seats."
   ],
   [
    "Elite Pro™ Jets",
    "Dual line up of high powered adjustable swim jets"
   ],
   [
    "Dual Zone Power",
    "Fitness Zone: 16HP, 3 pumps, 5.5KW heater, 50 amps; Hot Tub Zone: 8HP, 2 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2425 Gallons, 9179 Liters (hot tub zone: 425 Gallons / Fitness Zone: 2000 Gallons)"
   ],
   [
    "Weight (lbs.)",
    "2475 Dry, 21875 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "FX-ProView™ Control Center",
   "ProView™ Control Center",
   "Locking Safety Thermal Cover",
   "EverPure2™ Purification System",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "TempLock Technology"
  ]
 },
 "pdc-fx219s": {
  "specs": [
   [
    "Dimension",
    "227\" x 92\" x 56\", 118\" fitness area"
   ],
   [
    "Design Features",
    "Fitness zone features side entry steps with sculpted massage seat, open barrier-free fitness area, two RX6™ standing massage columns. Hot tub zone is a full featured 5 deep seat spa. Separate zones with filtration, heating, therapy and fitness action controls."
   ],
   [
    "Therapy Jets",
    "49 hydrotherapy stainless Reflections Jets™. Full body massage columns. Shoulder, upper and lower back, and hips in 6 seats."
   ],
   [
    "Elite Pro™ Jets",
    "Dual line up of high powered adjustable swim jets"
   ],
   [
    "Dual Zone Power",
    "Fitness Zone: 16HP, 3 pumps, 5.5KW heater, 50 amps; Hot Tub Zone: 8HP, 2 pumps, 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "2525 gallons (hot tub zone: 425 Gallons / Fitness Zone: 2100 Gallons)"
   ],
   [
    "Weight (lbs.)",
    "2475 Dry / 22675 Wet"
   ],
   [
    "Finish",
    "Silver Marble acrylic shell, Smoke Gray or Willow Brown cabinet"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration™",
   "RX6™ Full Body Massage Columns",
   "Reflections Jets™ Stainless Finish",
   "Highlights Lighting™ LED",
   "EverPure2™ Ozone with EverLite™",
   "AquaCross™ Tether Trainer",
   "AquaBar™ Molded Acrylic Grip",
   "FX-Proview™ Control Center",
   "Proview™ Control Center",
   "Locking Safety Thermal Cover",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse Lighting™",
   "Oasis Lighting™",
   "BlueTune™ Audio",
   "AquaBalance™ Stainless Side Balance Bars",
   "AquaForce™ Fitness Pulley",
   "WAVE™ WiFi Wireless Control",
   "MotionMat™ Fitness Mat",
   "MatTrax™ Step Treads",
   "LuminX™ Lighting",
   "TempLock Technology"
  ]
 },
 "pdc-splash12": {
  "specs": [
   [
    "Dimension",
    "144\" x 92\" x 50\" deep"
   ],
   [
    "Design Features",
    "Wide entry steps, full body therapy captain's chair, dual wide-open benches, contoured and corner seats. Up to 8 people."
   ],
   [
    "Therapy Jets",
    "59 hydrotherapy stainless Reflections Jets™. Shoulder, upper and lower back, calves, feet and neck jetting. Sculpted and bench seats."
   ],
   [
    "Elite ProTM Jet",
    "High powered resistance fitness jet."
   ],
   [
    "Fitness Spa Power",
    "12HP, 2 pumps; 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "1100 Gallons, 4164 Liters"
   ],
   [
    "Weight (lbs.)",
    "1125 Dry, 9925 Wet"
   ],
   [
    "Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration",
   "Reflections Jets™ Stainless Finish",
   "Highlights™ Lighting LED",
   "EverPure™ Ozone System with EverLite™",
   "ProView™ Control Center",
   "Locking Safety Thermal Cover",
   "SplashTrax™ Step Treads",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse™ Lighting",
   "WAVE™ WiFi Wireless Control",
   "AquaForce™ Pulley Trainer",
   "SplashMat Pak™ Steps, Seats, Floor Mat",
   "Oasis™ LED Lighting",
   "EverPure2™ UV-C Purification with EverLite2™",
   "BlueTune Audio",
   "AquaCross System",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-splash15": {
  "specs": [
   [
    "Dimension",
    "180\" x 92\" x 50\" deep"
   ],
   [
    "Design Features",
    "Wide entry steps, full body therapy captain's chair, dual wide-open benches, contoured and corner seats. Up to 10 people."
   ],
   [
    "Therapy Jets",
    "67 hydrotherapy Reflections Jets™. Shoulder, upper and lower back, calves, feet and neck jets. Sculpted and open bench seats."
   ],
   [
    "Elite ProTM Jet",
    "High powered resistance fitness jet."
   ],
   [
    "Fitness Spa Power",
    "12HP, 2 pumps; 5.5KW heater, 50 amps"
   ],
   [
    "Capacity",
    "1465 Gallons, 5456 Liters"
   ],
   [
    "Weight (lbs.)",
    "1525 Dry, 13245 Wet"
   ],
   [
    "Finish",
    "Midnight Graphite, Silverwood Grey & Driftwood Brown"
   ],
   [
    "Warranty",
    "35 structure / 15 finish / 5 component / 3 labor"
   ]
  ],
  "included": [
   "TemperBase™ Insulation",
   "Pristine Filtration",
   "Reflections Jets™ Stainless Finish",
   "Highlights™ Lighting LED",
   "EverPure™ Ozone System with EverLite™",
   "ProView™ Control Center",
   "Locking Safety Thermal Cover",
   "SplashTrax™ Step Treads",
   "Aqua Anchors",
   "PDC Spas Pre-lit Logo"
  ],
  "options": [
   "Eclipse™ Lighting",
   "WAVE™ WiFi Wireless Control",
   "AquaForce™ Pulley Trainer",
   "SplashMat Pak™ Steps, Seats, Floor Mat",
   "Oasis™ LED Lighting",
   "EverPure2™ UV-C Purification with EverLite2™",
   "BlueTune Audio",
   "AquaCross System",
   "LuminX™ Lighting",
   "Aqua Resistance Bands",
   "TempLock Technology"
  ]
 },
 "pdc-xd1": {
  "specs": [
   [
    "Dimensions",
    "93\" x 39\" x 32\""
   ],
   [
    "Seating Capacity",
    "1"
   ],
   [
    "Temperature Range",
    "40°F to 104°F"
   ],
   [
    "Capacity",
    "100 Gallons"
   ],
   [
    "Dry Weight",
    "320 lbs."
   ],
   [
    "Fill Weight",
    "1,154 lbs."
   ],
   [
    "Power Requirements",
    "110V / 15 Amp"
   ],
   [
    "Circulation Pump",
    "Energy efficient, 24-hour"
   ],
   [
    "LED Lighting",
    "Multi-color LEDs"
   ],
   [
    "Water Care",
    "EverPure™ Ozone Purification"
   ],
   [
    "Placement",
    "Fits standard doorways · indoor or outdoor"
   ]
  ],
  "included": [
   "Pure cold-water therapy",
   "Energy-efficient 24-hr circulation pump",
   "Multi-color LED lighting",
   "EverPure™ ozone water purification",
   "Fits through standard doorways",
   "Proudly made in the USA"
  ],
  "options": []
 },
 "pdc-xd1plus": {
  "specs": [
   [
    "Dimensions",
    "93\" x 39\" x 32\""
   ],
   [
    "Seating Capacity",
    "1"
   ],
   [
    "Temperature Range",
    "40°F to 104°F"
   ],
   [
    "Capacity",
    "100 Gallons"
   ],
   [
    "Hydrotherapy Jets",
    "7"
   ],
   [
    "Dry Weight",
    "320 lbs."
   ],
   [
    "Fill Weight",
    "1,154 lbs."
   ],
   [
    "Power Requirements",
    "110V / 15 Amp"
   ],
   [
    "Circulation Pump",
    "Energy efficient, 24-hour"
   ],
   [
    "LED Lighting",
    "Multi-color LEDs"
   ],
   [
    "Water Care",
    "EverPure™ Ozone Purification"
   ],
   [
    "Placement",
    "Fits standard doorways · indoor or outdoor"
   ]
  ],
  "included": [
   "7 hydrotherapy jets for muscle relief",
   "Pure cold-water therapy",
   "Energy-efficient 24-hr circulation pump",
   "Multi-color LED lighting",
   "EverPure™ ozone water purification",
   "Fits through standard doorways",
   "Proudly made in the USA"
  ],
  "options": []
 },
 "pdc-xd2": {
  "specs": [
   [
    "Dimensions",
    "90\" x 79\" x 32\""
   ],
   [
    "Seating Capacity",
    "Hot Tub: 4 seats · Cold Tub: 1 seat"
   ],
   [
    "Temperature Range",
    "40°F to 104°F"
   ],
   [
    "Hot Tub Capacity",
    "180 Gallons"
   ],
   [
    "Cold Tub Capacity",
    "63 Gallons"
   ],
   [
    "Dry Weight",
    "710 lbs."
   ],
   [
    "Fill Weight",
    "2,654 lbs."
   ],
   [
    "Power Requirements",
    "240V / 50 Amp"
   ],
   [
    "Horsepower",
    "6HP Peak, 3HP Continuous / 1.5HP Blower"
   ],
   [
    "Hydromassage Jet Pump",
    "1"
   ],
   [
    "Hydrotherapy Jets",
    "28"
   ],
   [
    "Air Therapy Jets",
    "27"
   ],
   [
    "Circulation Pump",
    "Energy efficient, 24-hour"
   ],
   [
    "LED Lighting",
    "Multi-color LEDs"
   ],
   [
    "Water Care",
    "EverPure™ Ozone Purification"
   ],
   [
    "Placement",
    "Fits standard doorways · indoor or outdoor"
   ]
  ],
  "included": [
   "Independent hot & cold zones for combination therapy",
   "Precision temperature control",
   "28 hydrotherapy + 27 air therapy jets",
   "Pure cold-water therapy",
   "Energy-efficient 24-hr circulation pump",
   "Multi-color LED lighting",
   "EverPure™ ozone water purification",
   "Fits through standard doorways",
   "Proudly made in the USA"
  ],
  "options": []
 }
};
